
import {
  Obra
} from '../index';


export class ObraRegistroParalisacao {
  "ObraId";
  "motivo";
  "novaDataDeRetomada";
  "descricaoDoMotivoDeParalisacao";
  "dataDaParalisacao";
  "responsabilidade";
  "dataDeRetomada";
  "subOfensores";
  "integracao";
  "registro";
  "id";
  Obra;
  constructor(data) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ObraRegistroParalisacao`.
   */
  static getModelName() {
    return "ObraRegistroParalisacao";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ObraRegistroParalisacao for dynamic purposes.
  **/
  static factory(data) {
    return new ObraRegistroParalisacao(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  static getModelDefinition() {
    return {
      name: 'ObraRegistroParalisacao',
      plural: 'ObraRegistroParalisacaos',
      path: 'ObraRegistroParalisacaos',
      properties: {
        "ObraId": {
          name: 'ObraId',
          type: 'string'
        },
        "motivo": {
          name: 'motivo',
          type: 'string'
        },
        "novaDataDeRetomada": {
          name: 'novaDataDeRetomada',
          type: 'Date'
        },
        "descricaoDoMotivoDeParalisacao": {
          name: 'descricaoDoMotivoDeParalisacao',
          type: 'string'
        },
        "dataDaParalisacao": {
          name: 'dataDaParalisacao',
          type: 'Date'
        },
        "responsabilidade": {
          name: 'responsabilidade',
          type: 'string'
        },
        "dataDeRetomada": {
          name: 'dataDeRetomada',
          type: 'Date'
        },
        "subOfensores": {
          name: 'subOfensores',
          type: 'string'
        },
        "integracao": {
          name: 'integracao',
          type: 'boolean'
        },
        "registro": {
          name: 'registro',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
        Obra: {
          name: 'Obra',
          type: 'Obra',
          model: 'Obra'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/ObraRegistroParalisacao.js